import { FC, useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { CustomTextField } from '@mgm/common/components/form';
import { TAddMemberOptions } from '../../type';

const AddMemberOptions: FC<TAddMemberOptions> = ({
  labelKey,
  setOption,
  name,
  rules = {},
  options,
  errorMsg,
  isExists,
}) => {
  const { t } = useTranslation(['inputs', 'warning']);

  const [isOpenInput, setIsOpenInput] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const addOption = () => {
    if (inputValue !== '') {
      setOption(inputValue);
    }
    setIsOpenInput(false);
    setInputValue('');
  };

  const isDisabled = useMemo(() => {
    const exists = isExists(inputValue.toLowerCase());

    if (exists) {
      setErrorMessage(`${t(errorMsg, { ns: 'warning', key: inputValue })}`);
    } else {
      setErrorMessage('');
    }

    return exists || inputValue.trim() === '';
  }, [inputValue, options, t]);

  return (
    <Box paddingTop={2}>
      {!isOpenInput ? (
        <Box display="flex" justifyContent="end">
          <Button
            variant="text"
            onClick={() => setIsOpenInput(true)}
          >
            +
            {' '}
            {t(`${labelKey}`, { ns: 'inputs' })}
          </Button>
        </Box>
      ) : (
        <div>
          <Box display="flex" alignItems="center">
            <CustomTextField
              onChange={setInputValue}
              isDisplayLabel={false}
              name={name}
              rules={rules}
            />
            <Button disabled={isDisabled} onClick={addOption} sx={{ ml: 1.5 }} size="medium" variant="contained">{t('add')}</Button>
          </Box>
          {errorMessage && (
            <Typography variant="caption" color="error" sx={{ mt: 1 }}>
              {errorMessage}
            </Typography>
          )}
        </div>
      ) }
    </Box>
  );
};

export {
  AddMemberOptions,
};
